export const PARAMS = {
    EYE: {
        identifier: 'eye_icon',
    },
    HEART: {
        identifier: 'heart_icon',
    },
    BAG: {
        identifier: 'bag_icon',
    },
    COMPASS: {
        identifier: 'compass_icon',
    },
    SEARCH: {
        identifier: 'search_icon',
    },
    SERVICE_ICON: {
        identifier: 'service_icon',
    },
};

export const PARAMS_MATCHER = /(\s*%{[a-zA-Z-_]+}\s*)/; // A param should be : %{param_identifier}
export const EXTRACT_PARAM_IDENTIFIER = /%{(.*)}/;
export const ICONS_SIZE = 24;
